import { render, staticRenderFns } from "./ReviewLaneClosureRequestBlockSidewalkListing.vue?vue&type=template&id=59018216&"
import script from "./ReviewLaneClosureRequestBlockSidewalkListing.vue?vue&type=script&lang=js&"
export * from "./ReviewLaneClosureRequestBlockSidewalkListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports